/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Happy_Green_Wren_BlowInputs */

const en_happy_green_wren_blow = /** @type {(inputs: Happy_Green_Wren_BlowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} selected`)
};

const de_happy_green_wren_blow = /** @type {(inputs: Happy_Green_Wren_BlowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ausgewählt`)
};

/**
* | output |
* | --- |
* | "{count} selected" |
*
* @param {Happy_Green_Wren_BlowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const happy_green_wren_blow = /** @type {((inputs: Happy_Green_Wren_BlowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Happy_Green_Wren_BlowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_happy_green_wren_blow(inputs)
	return de_happy_green_wren_blow(inputs)
});